/* eslint-disable @typescript-eslint/no-explicit-any */

import { AdaaHelper } from "../../../../../../../core/utils";
import { AdaaBoolean } from "../../../../../../constants/enums";
import { SharedFields } from "../../configs";
import { ScreenSectionConfigType, ScreenType } from "../../wf-difference.types";

const verticalAttachmentField: ScreenSectionConfigType = {
  field: "logoVerticalAttach",
  label: "entity.create.logo_vertical",
  view: "normal",
  isClickable: true,
  hasDiff: ($newValue: unknown, $oldValue: unknown) => {
    const $n = $newValue as { id: number };
    const $o = $oldValue as { id: number };
    return $n?.id !== $o?.id;
  },
  format: ($o) => ($o as any).logoVerticalAttach?.filename,
};

const horizontalAttachmentField: ScreenSectionConfigType = {
  field: "logoHorizontalAttach",
  label: "entity.create.logo_horizontal",
  view: "normal",
  isClickable: true,
  hasDiff: ($newValue: unknown, $oldValue: unknown) => {
    const $n = $newValue as { id: number };
    const $o = $oldValue as { id: number };
    return $n?.id !== $o?.id;
  },
  format: ($o) => ($o as any).logoHorizontalAttach?.filename,
};

const shortName: ScreenSectionConfigType = {
  field: "shortNameAE",
  label: "entity.create.shortName",
  view: "normal",
};

const entityType: ScreenSectionConfigType = {
  field: "entityType",
  label: "entity.create.entity_type",
  view: "normal",
  format: (data) => AdaaHelper.getItemValueByToken(data, "entityTypeName"),
};

const enablerField: ScreenSectionConfigType = {
  field: "enabler",
  label: "entity.create.enabler",
  view: "normal",
  format: (data: { enabler: string }) => {
    if (!AdaaHelper.isDefinedAndNotEmpty(data.enabler)) return "";
    else return data.enabler === AdaaBoolean.Y ? "common.form.label.yes" : "common.form.label.no";
  },
};

const addressFieldAE: ScreenSectionConfigType = {
  field: "addressAE",
  label: "entity.create.address_arabic",
  view: "normal",
};

const addressFieldEN: ScreenSectionConfigType = {
  field: "addressEN",
  label: "entity.create.address_english",
  view: "normal",
};

const cityFieldAE: ScreenSectionConfigType = {
  field: "cityAE",
  label: "entity.create.city_arabic",
  view: "normal",
};

const cityFieldEN: ScreenSectionConfigType = {
  field: "cityEN",
  label: "entity.create.city_english",
  view: "normal",
};

const geoX: ScreenSectionConfigType = {
  field: "geoX",
  label: "entity.create.geo_x",
  view: "normal",
};

const geoY: ScreenSectionConfigType = {
  field: "geoY",
  label: "entity.create.geo-y",
  view: "normal",
};

const zipCodeAE: ScreenSectionConfigType = {
  field: "zipCodeAE",
  label: "entity.create.zip_code_arabic",
  view: "normal",
};

const hqField: ScreenSectionConfigType = {
  field: "isHQ",
  label: "entity.create.hq",
  view: "normal",
  format: (data: { isHQ: string }) => (data.isHQ === AdaaBoolean.Y ? "common.form.label.yes" : "common.form.label.no"),
};

const entityOfficeConfig: ScreenSectionConfigType[] = [
  addressFieldAE,
  addressFieldEN,
  geoX,
  geoY,
  cityFieldAE,
  cityFieldEN,
  zipCodeAE,
  hqField,
];

const entityOffice: any = {
  view: "accordion",
  field: "entityOffice",
  title: ($o: unknown) => AdaaHelper.getItemValueByToken($o, "address"),
  idKey: "id",
  config: entityOfficeConfig,
  label: "entity.create.entity_offices",
};

export const entityScreenConfig = {
  type: "metric-actual-value" as ScreenType,
  sections: [
    ...SharedFields.name,
    ...SharedFields.description,
    shortName,
    entityType,
    verticalAttachmentField,
    horizontalAttachmentField,
    enablerField,
    entityOffice,
  ],
};
